import BasePicker from '@emoji-mart/react'
import Styles from 'components/FileEmojiPicker/FileEmojiPicker.module.scss'
import { BaseEmoji } from 'types'
import { useRef } from 'react'
import { Button } from 'blaze-ui/Button/Button'

export interface Props {
  onEmojiSelect: (emoji: BaseEmoji | null) => void
  theme: 'auto' | 'light' | 'dark'
  custom: any[]
  previewPosition: 'top' | 'bottom' | 'none'
  autoFocus: boolean
  categories: string[]
  categoryIcons: {}
}

export const Picker = (props: Partial<Props>) => {
  const pickerRef = useRef<HTMLDivElement>(null)

  setTimeout(() => {
    pickerRef.current
      ?.querySelector('em-emoji-picker')
      ?.shadowRoot?.firstElementChild?.getElementsByTagName('input')[0]
      ?.focus()
  }, 200)

  return (
    <>
      <div ref={pickerRef}>
        <BasePicker {...props} />
      </div>
      <div className={Styles.pickerTopBar}>
        <Button onPress={() => props.onEmojiSelect?.(null)} size="md" variant="secondary">
          Remove Emoji
        </Button>
      </div>
    </>
  )
}
